import {
    faClipboard,
    faComments,
    faEnvelope,
    faPhone,
    faMessages,
    faShareNodes,
} from "@fortawesome/pro-duotone-svg-icons";
import { InteractionType } from "@edgetier/watchtower-types";
import { unreachableCaseError } from "@edgetier/utilities";

/**
 * Get the icon applicable to the interaction being displayed.
 * @param interactionType The type of interaction.
 * @returns An icon relevant to the interaction.
 */
export const getInteractionIcon = (interactionType: InteractionType) => {
    switch (interactionType) {
        case InteractionType.Chat:
            return faComments;
        case InteractionType.Email:
            return faEnvelope;
        case InteractionType.Call:
            return faPhone;
        case InteractionType.Survey:
            return faClipboard;
        case InteractionType.Messaging:
            return faMessages;
        case InteractionType.SocialMedia:
            return faShareNodes;
        default:
            unreachableCaseError(interactionType);
            return faEnvelope;
    }
};
